import instance from "../config/interceptor";
import { BASE_API_URL } from "../config/api";

export const getBusinessProfile = async () => {
  let _response;
  try {
    const response = await instance.get(
      `${BASE_API_URL}/dashboard/business`
    );
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const postBusinessProfile = async (data) => {
  let _response;
  try {
    const response = await instance.post(
      `${BASE_API_URL}/dashboard/business`,
      data
    );
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};
